/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Service.jsx
 * description   : {{insert here}}
 * creation date : 26/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Flex,
    View,
    Text,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';

import {
    ViewPortContainer,
} from '@/components/snippets/CustomDiv';

import {
    ContentContainer,
} from '@/components/snippets/ContentDiv';

import {
    config_page_HOME_service as page_configuration,
} from '@/components/layouts/core';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function ServiceBadge({ title, children, ...rest }) {
    return (
        <Fragment>
            <View
                className='main-home-service-badge-parent'
                {...rest}
            >
                <Flex
                    direction='column'
                    className='main-home-service-badge'
                >
                    <Text
                        className='main-home-service-badge-title'
                    >
                        {title}
                    </Text>


                    <Text
                        className='main-home-service-badge-text'
                    >
                        {children}
                    </Text>
                </Flex>
            </View>
        </Fragment>
    );
}

function Service({ id }) {
    // Component context
    const { ctx } = useComponentContext();

    // Detect private access
    if (false === ctx.api.location.canBeDisplayed(page_configuration)) {
        return null;
    }

    return (
        <Fragment>
            <ContentContainer
                rightAligned={true}
                id={id}
                title='Service' // TODO: Translate message
            >
                <ViewPortContainer>
                    <Flex
                        direction='column'
                        gap={ctx.theme.tokens.space.zero}
                    >
                        <Flex
                            direction='column'
                            wrap='wrap'
                            className='main-home-service-badge-container'
                        >
                            <ServiceBadge
                                // TODO: Translate message
                                title='Experience, methodology, technology 4.0'
                            >
                                {/* TODO: Translate message */}
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                                arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                                Fusce cursus, sapien mollis bibendum mattis, magna orci sollicitudin metus,
                                eu malesuada erat diam non erat. Mauris enim justo, auctor in est vitae, tempus finibus risus.
                                Cras a augue consectetur, ultrices elit vel, ultricies nisi. Curabitur leo lacus,
                                vehicula vel commodo id, pulvinar vel lacus.
                            </ServiceBadge>

                            <ServiceBadge
                                // TODO: Translate message
                                title='Leading our clients to become First Movers in the market'
                            >
                                {/* TODO: Translate message */}
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                                arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                                Fusce cursus, sapien mollis bibendum mattis, magna orci sollicitudin metus,
                                eu malesuada erat diam non erat. Mauris enim justo, auctor in est vitae, tempus finibus risus.
                                Cras a augue consectetur, ultrices elit vel, ultricies nisi. Curabitur leo lacus,
                                vehicula vel commodo id, pulvinar vel lacus.
                            </ServiceBadge>

                            <ServiceBadge
                                // TODO: Translate message
                                title='Experience of Software Engineers and Technical Industry experts'
                            >
                                {/* TODO: Translate message */}
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                                arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                                Fusce cursus, sapien mollis bibendum mattis, magna orci sollicitudin metus,
                                eu malesuada erat diam non erat. Mauris enim justo, auctor in est vitae, tempus finibus risus.
                                Cras a augue consectetur, ultrices elit vel, ultricies nisi. Curabitur leo lacus,
                                vehicula vel commodo id, pulvinar vel lacus.
                            </ServiceBadge>

                            <ServiceBadge
                                // TODO: Translate message
                                title='Product: Tool & License + Support / Annual improvements'
                            >
                                {/* TODO: Translate message */}
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus volutpat,
                                arcu et semper hendrerit, lectus nunc interdum elit, sed tempus est lorem non ante.
                                Fusce cursus, sapien mollis bibendum mattis, magna orci sollicitudin metus,
                                eu malesuada erat diam non erat. Mauris enim justo, auctor in est vitae, tempus finibus risus.
                                Cras a augue consectetur, ultrices elit vel, ultricies nisi. Curabitur leo lacus,
                                vehicula vel commodo id, pulvinar vel lacus.
                            </ServiceBadge>
                        </Flex>
                    </Flex>
                </ViewPortContainer>
            </ContentContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Service;



// End of file
